import isEmpty from 'lodash/isEmpty';

const MAX_TEXT_LENGTH = 5000;

function handleError(error, resolve) {
  if (typeof Sentry !== 'undefined') Sentry.captureException(error);
  resolve({ error: true });
}

function withErrorHandling(handler, resolve) {
  return function errorHandler(event) {
    try {
      handler(event);
    } catch (error) {
      handleError(error, resolve);
    }
  };
}

function isJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

function useTextExtraction() {
  async function extractText(url, headers, body, blob, progress) {
    if (isEmpty(url)) return;

    const form = new FormData();
    form.append('document', blob);

    Object.entries(body).forEach(([key, value]) => {
      form.append(key, value);
    });

    const blobLog = `name: ${blob.name}, size: ${blob.size}, type: ${blob.type}`;

    return new Promise(function (resolve) {

      const xhr = new XMLHttpRequest();
      xhr.timeout = 60000;

      xhr.open('POST', url, true);

      for (const key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }

      xhr.addEventListener('load', withErrorHandling(event => {
        progress(100);

        if (xhr.status !== 200 && !isJSON(xhr.response)) {
          throw new Error(`Extract text failed with status: ${xhr.status} | ${xhr.response} | ${blobLog}`);
        }

        const result = JSON.parse(xhr.response);

        if (result.text_extracted || result.response) {
          resolve({ result: (result.text_extracted || result.response).trim().replaceAll(/\s\s+/g, ' ').substring(0, MAX_TEXT_LENGTH), error: false });
        } else {
          throw new Error(`Extract text response ok but no text extracted. | ${blobLog}`);
        }
      }, resolve));

      xhr.addEventListener('error', withErrorHandling(event => {
        progress(100);

        throw new Error(`Extract text request error. | ${blobLog}`);
      }, resolve));

      xhr.ontimeout = withErrorHandling((e) => {
        progress(100);

        throw new Error(`Extract text request timeout. | ${blobLog}`);
      }, resolve);

      if (xhr.upload) {
        xhr.upload.onprogress = function (event) {
          const percentage = Math.floor(event.loaded * 50 / event.total);
          progress(percentage);
        };
      }

      xhr.send(form);
    });
  }

  return [extractText];
}

export default useTextExtraction;
